import {
  Activity,
  AlertCircle,
  AlertTriangle,
  Archive,
  ArrowRight,
  BarChart,
  BarChart2,
  Bell,
  Book,
  BookOpen,
  Box,
  Briefcase,
  Building,
  Building2,
  Calendar,
  CalendarClock,
  Camera,
  Check,
  CheckCircle,
  ChevronDown,
  ChevronRight,
  CircleDot,
  Clipboard,
  ClipboardList,
  Clock,
  Cloud,
  Code,
  Cog,
  Command,
  Compass,
  Copy,
  CreditCard,
  Database,
  Download,
  Edit,
  ExternalLink,
  Eye,
  File,
  FileText,
  Filter,
  Flag,
  Folder,
  FolderOpen,
  FolderSearch,
  Gauge,
  Gift,
  Globe,
  Grid,
  Hash,
  Heart,
  HelpCircle,
  Home,
  Image,
  Images,
  Inbox,
  Info,
  Key,
  Laptop,
  Layers,
  Layout,
  LayoutDashboard,
  Link,
  List,
  Lock,
  LogOut,
  Mail,
  Map,
  MapPin,
  Menu,
  MessageCircle,
  MessageSquare,
  Mic,
  Monitor,
  MonitorCog,
  Moon,
  MoreHorizontal,
  Music,
  Navigation,
  Package,
  PackageCheck,
  PackageOpen,
  PackageSearch,
  Paperclip,
  Pencil,
  Phone,
  PieChart,
  Pin,
  Play,
  Plus,
  Power,
  Printer,
  Radio,
  RefreshCw,
  Repeat,
  RotateCw,
  Save,
  ScanSearch,
  Search,
  Send,
  Server,
  Settings,
  Share,
  Shield,
  ShieldCheck,
  ShoppingBag,
  ShoppingCart,
  Sidebar,
  Sliders,
  Smartphone,
  Speaker,
  Star,
  Sun,
  Table,
  TableOfContents,
  Tag,
  Target,
  Terminal,
  Thermometer,
  ThumbsUp,
  ToggleLeft,
  Trash,
  Trash2,
  TrendingUp,
  Truck,
  Tv,
  Type,
  Umbrella,
  Unlock,
  Upload,
  User,
  UserCheck,
  UserPlus,
  Users,
  Video,
  Voicemail,
  Volume2,
  Wallet,
  Watch,
  Wifi,
  Wind,
  Wrench,
  X,
  Zap,
  ShieldUser,
  FlaskConical,
  LibraryBig,
  GitBranch,
  GitPullRequestArrow,
  LineChart,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

const iconMap: Record<string, LucideIcon> = {
  activity: Activity,
  'alert-circle': AlertCircle,
  'alert-triangle': AlertTriangle,
  archive: Archive,
  'arrow-right': ArrowRight,
  'bar-chart': BarChart,
  'bar-chart-2': BarChart2,
  'line-chart': LineChart,
  bell: Bell,
  book: Book,
  'book-open': BookOpen,
  box: Box,
  briefcase: Briefcase,
  building: Building,
  'building-2': Building2,
  calendar: Calendar,
  'calendar-clock': CalendarClock,
  camera: Camera,
  check: Check,
  'check-circle': CheckCircle,
  'chevron-down': ChevronDown,
  'chevron-right': ChevronRight,
  'circle-dot': CircleDot,
  clipboard: Clipboard,
  'clipboard-list': ClipboardList,
  clock: Clock,
  cloud: Cloud,
  code: Code,
  cog: Cog,
  command: Command,
  compass: Compass,
  copy: Copy,
  'credit-card': CreditCard,
  database: Database,
  download: Download,
  edit: Edit,
  'external-link': ExternalLink,
  eye: Eye,
  file: File,
  'file-text': FileText,
  filter: Filter,
  flag: Flag,
  'flask-conical': FlaskConical,
  folder: Folder,
  'folder-open': FolderOpen,
  'folder-search': FolderSearch,
  gauge: Gauge,
  gift: Gift,
  'git-branch': GitBranch,
  'git-pull-request-arrow': GitPullRequestArrow,
  globe: Globe,
  grid: Grid,
  hash: Hash,
  heart: Heart,
  'help-circle': HelpCircle,
  home: Home,
  image: Image,
  images: Images,
  inbox: Inbox,
  info: Info,
  key: Key,
  laptop: Laptop,
  layers: Layers,
  layout: Layout,
  'layout-dashboard': LayoutDashboard,
  'library-big': LibraryBig,
  link: Link,
  list: List,
  lock: Lock,
  'log-out': LogOut,
  mail: Mail,
  map: Map,
  'map-pin': MapPin,
  menu: Menu,
  'message-circle': MessageCircle,
  'message-square': MessageSquare,
  mic: Mic,
  monitor: Monitor,
  'monitor-cog': MonitorCog,
  moon: Moon,
  'more-horizontal': MoreHorizontal,
  music: Music,
  navigation: Navigation,
  package: Package,
  'package-check': PackageCheck,
  'package-open': PackageOpen,
  'package-search': PackageSearch,
  paperclip: Paperclip,
  pencil: Pencil,
  phone: Phone,
  'pie-chart': PieChart,
  pin: Pin,
  play: Play,
  plus: Plus,
  power: Power,
  printer: Printer,
  radio: Radio,
  'refresh-cw': RefreshCw,
  repeat: Repeat,
  'rotate-cw': RotateCw,
  save: Save,
  'scan-search': ScanSearch,
  search: Search,
  send: Send,
  server: Server,
  settings: Settings,
  share: Share,
  shield: Shield,
  'shield-check': ShieldCheck,
  'shield-user': ShieldUser,
  'shopping-bag': ShoppingBag,
  'shopping-cart': ShoppingCart,
  sidebar: Sidebar,
  sliders: Sliders,
  smartphone: Smartphone,
  speaker: Speaker,
  star: Star,
  sun: Sun,
  table: Table,
  'table-of-contents': TableOfContents,
  tag: Tag,
  target: Target,
  terminal: Terminal,
  thermometer: Thermometer,
  'thumbs-up': ThumbsUp,
  'toggle-left': ToggleLeft,
  tool: Wrench,
  trash: Trash,
  'trash-2': Trash2,
  'trending-up': TrendingUp,
  truck: Truck,
  tv: Tv,
  type: Type,
  umbrella: Umbrella,
  unlock: Unlock,
  upload: Upload,
  user: User,
  'user-check': UserCheck,
  'user-plus': UserPlus,
  users: Users,
  video: Video,
  voicemail: Voicemail,
  'volume-2': Volume2,
  wallet: Wallet,
  watch: Watch,
  wifi: Wifi,
  wind: Wind,
  wrench: Wrench,
  x: X,
  zap: Zap,
};

/**
 * Normalize an icon name to kebab-case.
 * Handles camelCase, PascalCase, and snake_case inputs.
 */
function toKebabCase(name: string): string {
  return name
    .replace(/_/g, '-')
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1-$2')
    .toLowerCase();
}

/**
 * Get a Lucide icon component by name.
 * Accepts kebab-case, camelCase, PascalCase, or snake_case.
 * Returns HelpCircle as fallback.
 */
export function getIcon(name: string | null | undefined): LucideIcon {
  if (!name) return HelpCircle;
  const normalized = toKebabCase(name.trim());
  return iconMap[normalized] ?? HelpCircle;
}
